import styled from 'styled-components';
import { Paper, theme, Button, minBp } from '@triumph/shared';

export const Wrap = styled(Paper)`
  padding: 30px 20px;
  margin-bottom: 24px;
  position: relative;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 11px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 27px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    padding-bottom: 30px;
    margin-bottom: 40px;
  }
`;

export const PXTitle = styled(Title)`
  @media ${minBp('desktop')} {
    margin-bottom: 16px;
  }
`;

export const PXDescription = styled(Description)`
  color: black;
  margin-bottom: 20px;
  padding-bottom: 0;
  border: 0;

  @media ${minBp('desktop')} {
    margin-bottom: 24px;
    padding-bottom: 0;
  }
`;

export const FormContainer = styled.div`
  @media ${minBp('tablet')} {
    max-width: 390px;
  }

  label {
    cursor: default;
  }
`;

export const Rule = styled.hr`
  border: 0;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin: 32px 0;

  @media ${minBp('desktop')} {
    margin: 47px 0 40px;
  }
`;

export const ToggleFieldGroup = styled.div`
  margin: 0 0 40px;

  @media ${minBp('desktop')} {
    margin: 0 0 32px;
  }
`;

export const ContinueButton = styled(Button)`
  margin-top: 24px;

  @media ${minBp('desktop')} {
    margin-top: 40px;
  }
`;
